import AssignVoucherDialog from "@saleor/components/AssignVoucherDialog";
import { DEFAULT_INITIAL_SEARCH_DATA } from "@saleor/config";
import { configurationMenuUrl } from "@saleor/configuration";
import { voucherUrl } from "@saleor/discounts/urls";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import useVoucherSearch from "@saleor/searches/useVoucherSearch";
import createDialogActionHandlers from "@saleor/utils/handlers/dialogActionHandlers";
import { mapEdgesToItems } from "@saleor/utils/maps";
import React from "react";
import { useIntl } from "react-intl";

import PopupDetailPage, {
  PopupFormData
} from "../../components/PopupDetailPage/PopupDetailPage";
import {
  useLoginPopupCreateDefaultMutation,
  usePopupAddVoucherMutation,
  usePopupRemoveVoucherMutation,
  useUpdatePopupMutation
} from "../../mutations";
import { useLoginpopupListQuery } from "../../queries";
import { PopipUrl, PopupUrlDialog, PopupUrlQueryParams } from "../../urls";

interface PopupDetailsProps {
  params: PopupUrlQueryParams;
}
const PopupDetails: React.FC<PopupDetailsProps> = ({ params }) => {
  const notify = useNotifier();
  const intl = useIntl();

  const { data, loading, refetch } = useLoginpopupListQuery({
    variables: {
      first: 1
    }
  });
  const id = data?.loginpopup?.edges[0] ? data.loginpopup.edges[0].node.id : "";
  const navigate = useNavigator();
  const [openModal, closeModal] = createDialogActionHandlers<
    PopupUrlDialog,
    PopupUrlQueryParams
  >(navigate, params => PopipUrl(params), params);

  const [popupUpdate, popupUpdateOpts] = useUpdatePopupMutation({
    onCompleted: data => {
      if (data.loginpopupUpdate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Update Popup Success"
          })
        });
      }
    }
  });

  const [defaultCreate] = useLoginPopupCreateDefaultMutation({
    onCompleted: data => {
      if (data.loginpopupCreateDefault.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Default Popup Created"
          })
        });
        refetch();
      }
    }
  });
  const handleSubmit = async (data: PopupFormData) => {
    // eslint-disable-next-line no-console
    // console.log(data);
    const input = {
      ...data
    };
    const result = await popupUpdate({
      variables: {
        id,
        input
      }
    });
    return result.data.loginpopupUpdate.errors;
  };
  const { search, loadMore, result } = useVoucherSearch({
    variables: DEFAULT_INITIAL_SEARCH_DATA
  });
  const [assignVoucher, assignVoucherOpts] = usePopupAddVoucherMutation({
    onCompleted: data => {
      if (data.loginpopupAddVoucher.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Added voucher to Popup"
          })
        });
        closeModal();
        refetch();
      }
    }
  });
  const [unassignVoucher] = usePopupRemoveVoucherMutation({
    onCompleted: data => {
      if (data.loginpopupRemoveVoucher.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Removed voucher to Popup"
          })
        });
        refetch();
      }
    }
  });
  return (
    <>
      <PopupDetailPage
        popup={id === "" ? null : data?.loginpopup?.edges[0].node}
        disabled={loading}
        onSubmit={handleSubmit}
        onBack={() => navigate(configurationMenuUrl)}
        saveButtonBarState={popupUpdateOpts.status}
        onRowClick={id => () => navigate(voucherUrl(id))}
        onDeleteVoucher={code =>
          unassignVoucher({
            variables: {
              loginPopup: id,
              voucherCode: code
            }
          })
        }
        defaultCreate={() => defaultCreate({})}
        onAddVoucher={() => openModal("assign-voucher")}
      />
      <AssignVoucherDialog
        confirmButtonState={assignVoucherOpts.status}
        open={params.action === "assign-voucher"}
        hasMore={result.data?.search?.pageInfo.hasNextPage}
        onFetch={search}
        onFetchMore={loadMore}
        loading={result.loading}
        onClose={closeModal}
        onSubmit={vouchers =>
          assignVoucher({
            variables: {
              loginPopup: id,
              voucher: vouchers.map(voucher => voucher.id)
            }
          })
        }
        vouchers={mapEdgesToItems(result?.data?.search)?.filter(
          suggestedVoucher => suggestedVoucher.id
        )}
      />
    </>
  );
};
export default PopupDetails;
